import { getCurrencyOptions } from '@company/shared'

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select'
import { useCurrencies } from '@/hooks'

interface CurrencySelectorProps {
    /** 当前选中的货币代码 */
    value: string
    /** 货币变更回调 */
    onValueChange: (value: string) => void
    /** 是否禁用 */
    disabled?: boolean
    /** 自定义类名 */
    className?: string
}

/**
 * 货币选择器组件
 * 从 API 获取启用的货币列表，如果 API 失败则回退到静态列表
 */
export function CurrencySelector({
    value,
    onValueChange,
    disabled,
    className = 'w-24',
}: CurrencySelectorProps) {
    const { data: currencies, isLoading } = useCurrencies()

    // 使用 API 数据，失败时回退到静态列表
    const options =
        currencies && currencies.length > 0
            ? currencies.map((c) => ({ value: c.code, label: c.code }))
            : getCurrencyOptions()

    return (
        <Select value={value} onValueChange={onValueChange} disabled={disabled || isLoading}>
            <SelectTrigger className={className}>
                <SelectValue placeholder="货币" />
            </SelectTrigger>
            <SelectContent>
                {options.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                        {option.value}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}

